<template lang="pug">
  .TheFooterSocialLinks.social-footer
    ul.social-footer__list
      li.social-footer__list-item
        a.social-footer__list-item-link.link-with-opacity(
          target="_blank",
          rel="noopener nofollow",
          aria-label="Twitter",
          :href="CONTACTS.twitter")
          BrandsTwitterIcon.svg-icon.twitter-icon.social-footer__list-item-icon
      li.social-footer__list-item
        a.social-footer__list-item-link.link-with-opacity(
          target="_blank",
          rel="noopener nofollow",
          aria-label="Facebook",
          :href="CONTACTS.facebook")
          BrandsFacebookFIcon.svg-icon.facebook-f-icon.social-footer__list-item-icon
      li.social-footer__list-item
        a.social-footer__list-item-link.link-with-opacity(
          target="_blank",
          rel="noopener nofollow",
          aria-label="Instagram",
          :href="CONTACTS.instagram")
          BrandsInstagramIcon.svg-icon.instagram-icon.social-footer__list-item-icon
      li.social-footer__list-item
        a.social-footer__list-item-link.link-with-opacity(
          target="_blank",
          rel="noopener nofollow",
          aria-label="Linkedin",
          :href="CONTACTS.linkedin")
          BrandsLinkedinInIcon.svg-icon.linkedin-in-icon.social-footer__list-item-icon
      li.social-footer__list-item
        a.social-footer__list-item-link.link-with-opacity(
          target="_blank",
          rel="noopener nofollow",
          aria-label="YouTube",
          :href="CONTACTS.youtube")
          BrandsYouTubeIcon.svg-icon.youtube-icon.social-footer__list-item-icon
      li.social-footer__list-item
        a.social-footer__list-item-link.link-with-opacity(
          target="_blank",
          rel="noopener nofollow",
          aria-label="RSS Link",
          :href="rssLink")
          SolidRssIcon.svg-icon.rss-icon.social-footer__list-item-icon
</template>

<script>
import CONFIG from 'Config';
import { CONTACTS } from 'Config/constans';
import SolidRssIcon from 'images/svg-icons/solid-rss.svg';
import BrandsTwitterIcon from 'images/svg-icons/brands-twitter.svg';
import BrandsFacebookFIcon from 'images/svg-icons/brands-facebook-f.svg';
import BrandsInstagramIcon from 'images/svg-icons/brands-instagram.svg';
import BrandsLinkedinInIcon from 'images/svg-icons/brands-linkedin-in.svg';
import BrandsYouTubeIcon from 'images/svg-icons/solid-youtube.svg';

export default {
  name: 'TheFooterSocialLinks',
  components: {
    SolidRssIcon,
    BrandsTwitterIcon,
    BrandsFacebookFIcon,
    BrandsInstagramIcon,
    BrandsLinkedinInIcon,
    BrandsYouTubeIcon,
  },
  staticData: {
    rssLink: CONFIG.urls.rssLink,
    CONTACTS,
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.social-footer
  display: flex
  flex-direction: row
  justify-content: space-between
  align-items: flex-start
  &__list
    display: flex
    list-style-type: none
    width: 100%
    @media screen and (max-width: 1024px)
      margin-bottom: 0
    @media screen and (max-width: 1000px)
      max-width: 350px
      justify-content: space-between
    @media screen and (max-width: 991px)
      margin-bottom: 0
  &__list-item
    padding-bottom: 0
    padding-right: 20px
    @media screen and (max-width: 767px)
      line-height: 20px
    &:last-child
      padding-right: 0
  &__list-item-link
    display: flex
  &__list-item-icon
    height: 20px
    width: auto
</style>
